import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Big closing CTA. Uses the amber accent as a full bleed on a slightly
 * darker slate mat so it feels like a final destination, not another
 * feature row.
 */
export default function FinalCTA() {
  return (
    <section
      className="relative bg-primary text-primary-foreground overflow-hidden"
      data-testid="landing-final-cta"
    >
      {/* amber wash */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(50% 60% at 50% 60%, hsl(28 95% 53% / 0.35) 0%, transparent 65%)",
        }}
      />
      {/* seam */}
      <div className="seam" aria-hidden="true" />

      <div className="relative max-w-[1000px] mx-auto px-5 md:px-8 py-20 md:py-32 text-center reveal">
        <div className="mono text-[11px] uppercase tracking-[0.3em] text-accent">
          // Stop chasing paperwork
        </div>
        <h2 className="mt-4 text-4xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[1.02]">
          Ready to run the day,<br className="hidden md:block" />
          <span className="text-accent"> not the paperwork?</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-primary-foreground/70 leading-relaxed">
          7-day free trial. No card. Import your customers in an afternoon and be quoting from your phone before dinner.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/signup"
            className="group inline-flex items-center gap-2 bg-accent text-accent-foreground px-7 py-4 rounded-md font-black text-base hover:bg-accent/90 shadow-[0_8px_30px_rgb(244,114,22,0.35)] hover:shadow-[0_12px_50px_rgb(244,114,22,0.5)] transition-all hover:-translate-y-[2px]"
            data-testid="landing-final-cta-primary"
          >
            Start free trial
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 border border-primary-foreground/25 hover:border-primary-foreground/50 px-7 py-4 rounded-md font-semibold text-base hover:bg-primary-foreground/5 transition-all"
            data-testid="landing-final-cta-secondary"
          >
            Sign in
          </Link>
        </div>
      </div>
    </section>
  );
}
